import './App.css';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom'
import Home from './Home';
import Hoteldeals from './Hoteldeals';
import Nav from './Nav';
import Footer from './Footer';
import Grouprate from './Grouprate';
import Account from './Account';
import Flag from './Flag';
import Currency from './Currency';
import More from './More';
import Extendedstay from './Extendedstay';
import Signup from './Signup'
import Forgotpassword from './Forgotpassword';





function App() {


  return (
    <Router>
              <Nav />

      <div className="App">
        <Switch>
        <Route path="/forgotpword">
            <Forgotpassword />  
          </Route>
        <Route path="/signup">
            <Signup />  
          </Route>
        <Route path="/account">
            <Account />  
          </Route>
        <Route path="/flag">
            <Flag />  
          </Route>
        <Route path="/currency">
            <Currency />  
          </Route>
        <Route path="/more">
            <More />  
          </Route>
       
        <Route path="/extendedstays">
            <Extendedstay />  
          </Route>
          <Route path="/grouprates">
            <Grouprate />  
          </Route>
          <Route path="/hoteldeals">
            <Hoteldeals />  
          </Route>
          <Route path="/footer">
            <Footer />  
          </Route>
          <Route path="/">
            <Home />  
          </Route>
        </Switch>
      </div>

    </Router>


  );
}

export default App;
